var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadgeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 273,
    viewBox: "0 0 206 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.798 208.851L145.892 251.325L102.929 221.468L59.7249 251.353L61.8209 208.851H43.6761L40.5488 272.28H61.3287L102.905 243.522L144.289 272.28H165.07L161.942 208.851H143.798Z",
    fill: "url(#paint0_linear_1157_16835)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.089 79.1112L191.846 51.8966L168.901 37.2132L154.215 14.266L127 13.02L102.81 0.492188L78.6201 13.0229L51.4049 14.2688L36.7188 37.2132L13.7738 51.8966L12.5313 79.1112L0 103.302L12.5313 127.492L13.7772 154.706L36.7188 169.39L51.4027 192.338L78.6178 193.581L102.81 206.111L127 193.581L154.215 192.338L168.899 169.39L191.845 154.709L193.089 127.495L205.62 103.304L193.089 79.1112ZM175.166 122.69L174.168 144.502L155.776 156.27L144.008 174.662L122.196 175.659L102.81 185.701L83.422 175.659L61.6097 174.662L49.8413 156.27L31.4519 144.502L30.4557 122.69L20.4084 103.302L30.4534 83.9171L31.4519 62.1019L49.8413 50.3335L61.6097 31.9424L83.422 30.9456L102.81 20.9023L122.198 30.9451L144.01 31.9418L155.779 50.3329L174.168 62.1019L175.164 83.9142L185.211 103.302L175.166 122.69Z",
    fill: "url(#paint1_linear_1157_16835)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1157_16835",
    x1: 150.285,
    y1: 240.565,
    x2: 40.5488,
    y2: 240.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBA6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A981FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1157_16835",
    x1: 181.206,
    y1: 103.302,
    x2: -2.0192e-8,
    y2: 103.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBA6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A981FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeIcon);
export default __webpack_public_path__ + "static/media/badge_icon.66ed460c60792e0f157473321ed5b84b.svg";
export { ForwardRef as ReactComponent };